import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { get } from 'lodash';

import { LoadingBase } from 'Components';
import { Filter, Main } from 'Containers';
import { errorToast } from 'Common/ToastHelper';

import { ApplicationGridForm } from './components/ApplicationGridForm';
import * as ViewApplicationDistributionSelectors from './state/selectors';
import * as ViewApplicationDistributionActions from './state/actions';
import { ViewApplicationDistributionFieldEnum } from 'Common/FieldEnum';

import * as SecuritySelectors from 'Common/Security/state/selectors';

class ViewApplicationDistribution extends Component {
  async componentDidMount() {
    const { getPage } = this.props;
    await getPage();
  }

  componentDidUpdate(prevProps) {
    errorToast(this.props, prevProps, 'fetchError', this.props.clearErrors);
  }

  render() {
    return (
      <Fragment>
        {this.props.loading && <LoadingBase />}
        <Filter title={'View Application Distribution'} />
        <Main shouldNotUsePageWidth>
          <ApplicationGridForm
            initialValues={{
              [ViewApplicationDistributionFieldEnum.TypeId]: get(
                this.props,
                'results.TypeId'
              ),
            }}
            {...this.props}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  loading: ViewApplicationDistributionSelectors.getFetching(state),
  loadingResults: ViewApplicationDistributionSelectors.getFetchingResults(
    state
  ),
  fetchError: ViewApplicationDistributionSelectors.getFetchError(state),
  typeOptions: ViewApplicationDistributionSelectors.getTypeOptions(state),
  results: ViewApplicationDistributionSelectors.getResults(state),
  formValues: ViewApplicationDistributionSelectors.getViewApplicationDistributionFormValues(
    state
  ),
  accessInfo: SecuritySelectors.getAccessInfo(state),
});

const mapDispatchToProps = {
  getPage: ViewApplicationDistributionActions.getPage,
  getResults: ViewApplicationDistributionActions.getResults,
  clearErrors: ViewApplicationDistributionActions.clearErrors,
};

ViewApplicationDistribution = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ViewApplicationDistribution)
);

export { ViewApplicationDistribution };



// WEBPACK FOOTER //
// ./src/pages/viewapplicationdistribution/ViewApplicationDistribution.js